<div class="modal-header">
    <h5 class="modal-title">Add Images</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal ()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="nav-tabs-horizontal tab-body">
  <ul ngbNav #tabSet="ngbNav" class="nav-tabs">
    <li ngbNavItem>
        <a ngbNavLink>Gallery</a>
      <ng-template ngbNavContent>
        <app-gallery [currentImage]="currentImage" saveBtnLabel="Insert"></app-gallery>
      </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Upload a New Image</a>
      <ng-template ngbNavContent>
        <app-upload saveBtnLabel="Insert"></app-upload>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="tabSet" class="mt-2"></div>

</div>
